

import './Cart.css'
import CartDetail from './CartDetail';
import { isTokenValid,getPayload } from '../../helpers/jwt';
import { useHistory } from 'react-router-dom';
import { ToastContainer,toast } from 'react-toastify';
const ShoppingCart = () => {
    const history = useHistory();
    const handleCheckoutNavigation = (e) => {
        e.preventDefault();
        if (isTokenValid("auth_token"))
            return history.push('check-out-form');

        toast.success("Login or Signup to order", {
            position: "top-right",
            autoClose: 2000,
            });

            // Delay navigation
            setTimeout(() => {
                history.push({
                    pathname: '/customer-portal',
                    state: {
                    nav_path: '/check-out-form'
                    }
                });
            }, 2000);
    };
    
    return(
        <>
            <CartDetail/>
            <div className='container'>
                <button 
                    className='cart-btn' 
                    onClick={handleCheckoutNavigation}
                >
                    Checkout
                </button>
            </div>
        </>
    );
}



export default ShoppingCart;